export default __webpack_public_path__ + "static/reports-presentation_by-4041ca99e28d91a78ea65bb7231471e1.webp";